import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { ICustomerNumberInfo, ILSystem } from '@mwe/models';
import { formatAccountNumber, getBusinessCompanyNameFromIlSapData, translateCategoryInstant } from '@mwe/utils';
import { TooltipCardComponent } from '../tooltip-card/tooltip-card.component';
import { SelectionCardComponent } from '../cards/selection-card/selection-card.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mwe-customer-number-info-tooltip-card',
  templateUrl: './customer-number-info-tooltip-card.component.html',
  imports: [TooltipCardComponent, SelectionCardComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerNumberInfoTooltipCardComponent {
  private translateService = inject(TranslateService);
  hasContent = input<boolean>();
  isClickable = input(false);
  tooltipCardClass = input<{ [value: string]: boolean }>();
  useRedesignedCard = input(false);
  customerNumberInfo = input<ICustomerNumberInfo | undefined>(undefined);
  onClick = output<void>();

  customerNumberTextLabel = 'Kundennummer: ';

  tooltipHeader = computed(() => {
    const data = this.customerNumberInfo();
    if (!data) {
      return '';
    }
    const companyName = getBusinessCompanyNameFromIlSapData(data?.geschaeftsPartner?.organisation);
    const prefix = companyName ? companyName : `${data?.firstName} ${data?.lastName}`;
    const translatedCategories = data?.productCategories?.map(category => translateCategoryInstant(category, this.translateService));
    return `${prefix} | ${translatedCategories.join(', ')}`;
  });

  tooltipContent = computed(() => {
    const data = this.customerNumberInfo();
    if (!data) {
      return '';
    }
    // do not use categories, array contains translated strings
    if (data.systemId === ILSystem.ISX100) {
      const accountNumber = formatAccountNumber(data.accountNumber, true);
      return this.customerNumberTextLabel + accountNumber;
    }
    return this.customerNumberTextLabel + data.customerNumber;
  });

  emitOnClickEvent() {
    this.onClick.emit();
  }
}
